import { Fragment } from "react/jsx-runtime";
import { EditClassProps } from "../../Utils/Types";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  AutocompleteChangeReason,
  TextField,
} from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { getValueForAutocomplete, isMobile } from "../../Utils/Utils";

export default function EditClass(props: EditClassProps) {
  const { classes, control } = props;
  
  return (
    <Fragment>
      <Controller
        name={`classId`}
        control={control}
        defaultValue={null}
        render={({ field: { ref, ...field }, fieldState: { error } }) => {
          return (
            <>
              <Autocomplete
                size="small"
                disableClearable
                id={`classId`}
                fullWidth={true}
                freeSolo={false}
                disablePortal
                noOptionsText={Vocabulary.noResultsFound}
                isOptionEqualToValue={(option: any, value: any) => {
                  if (typeof value === "string") {
                    return option._id === value;
                  } else {
                    return option?._id === value?._id;
                  }
                }}
                getOptionLabel={(option: any) => option.name}
                options={classes || []}
                value={getValueForAutocomplete(classes, field.value)}
                onChange={(
                  e: any,
                  product: string,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => {
                  field.onChange(details.option._id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      style: {
                        minWidth: isMobile() ? "100%" : "20vw",
                      },
                      ...params.InputProps,
                      rows: 4,
                      multiline: false,
                      inputComponent: "textarea",
                    }}
                    fullWidth={true}
                    name={`classId`}
                    label={Vocabulary.class}
                    variant="standard"
                  />
                )}
              />
            </>
          );
        }}
      />
    </Fragment>
  );
}
